<template>
  <path
    d="M10.5303 2.46973C10.2374 2.17683 9.76262 2.17683 9.46973 2.46973L4.46973 7.46973C4.17689 7.76262 4.17685 8.2374 4.46973 8.53027L9.46973 13.5303C9.7626 13.8231 10.2374 13.8231 10.5303 13.5303C10.8232 13.2374 10.8232 12.7626 10.5303 12.4697L6.06055 8L10.5303 3.53027C10.8232 3.23738 10.8232 2.76262 10.5303 2.46973Z"
    fill="white"
  />
</template>
